'use client';
import React, { useContext } from 'react';
import { IDeviceState } from '~/helper/read-device-from-headers';

const DeviceContext = React.createContext<IDeviceState>({} as IDeviceState);

export const DeviceProvider = ({
  value,
  children,
}: {
  value: IDeviceState;
  children: React.ReactNode;
}) => {
  return (
    <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>
  );
};

const useDevice = () => useContext(DeviceContext);

export default useDevice;
